<template>
  <LayoutContainer :props="props" :id="props.anchor || ''">
    <div class="kaer-goods-double">
      <goods
        v-for="(goods, index) in goodsList"
        :key="goods.itemCode"
        :goods="goods"
        :config="props.list[index]"
        :index="index"
        :clickTrackId="clickGoodsCode || clickTrackId"
        :componentId="propsComponentId"
      />
    </div>
  </LayoutContainer>
</template>

<script>
import goodsMixins from '@/mixins/goods-mixins';
import LayoutContainer from '@/components/layout-container';

export default {
  name: 'kaer-goods-double',
  components: { LayoutContainer },
  mixins: [goodsMixins],
  data() {
    return {
      trackId: 'TMS-moudle-product',
      clickTrackId: 'TMS-click-moudle-product',
    };
  },
  mounted() {
    console.log(this.goodsList);
  },
};
</script>

<style lang="less" scoped>
.kaer-goods-double {
  // padding: 0 12px;
  display: flex;
  flex-wrap: wrap;
  flex: auto;
}
</style>
